import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatSnackBar } from '@angular/material';
import { FormGroup } from '@angular/forms';
import { AutenticationService } from '../../../../autentication/autentication.service';
import { Auth } from '../../../../autentication/Auth';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../../shared/EventTypes';
import { PixLimitsReturn, PixLimitsReturnTipo } from '../../models/limits-return.model';
import { PixLimitsService } from '../limits.service';
import { SharedModalInfoComponent } from '../../../../shared/modal-info/modal-info.component';

@Component({
	selector: 'app-adjust-limits-assignature',
	templateUrl: './assignature.component.html',
	styleUrls: ['./assignature.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixAdjustLimitsAssignatureComponent implements OnInit {

	public submitted = false;
	public form: FormGroup;

	private selectedLimit: PixLimitsReturn;

	constructor(
		private route: ActivatedRoute,
		private autenticationService: AutenticationService,
		private router: Router,
		public dialog: MatDialog,
		private snackBar: MatSnackBar,
		private pixLimitsService: PixLimitsService
	) {}

	ngOnInit() {
		this.selectedLimit = this.pixLimitsService.getSelectedLimit();

		if (this.invalidParams()) {
			this.goBack();
		}
	}

	invalidParams(): boolean {
		return this.selectedLimit === undefined || this.selectedLimit.tipo === undefined;
	}

	onSetSignatureForm(form: FormGroup) {
		this.form = form;
	}

	submit(message: boolean) {
		this.submitted = message;

		if (this.submitted && this.form.valid) {
			this.addAuthToken();
			this.sendAssignature();
		}
	}

	addAuthToken() {
		if (this.form.value.token) {
			Auth.passToken = this.form.value.token;
		}
	}

	addAuthSignature() {
		if (this.form.value.eletronicSignature) {
			Auth.assinaturaEletronica = this.form.value.eletronicSignature;
		}
	}

	sendAssignature() {
		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(data => {
			if (data.Sucesso) {
				this.addAuthSignature();
				this.sendRequest();
			}
		}, error => {
			this.handleError(error);
		});
	}

	sendRequest() {
		const model = this.selectedLimit;

		this.pixLimitsService.changeLimitValue(model).subscribe(data => {
			if (data.Sucesso) {
				this.openModal();
			}
		}, error => {
			this.handleError(error);
		});
	}

	public openModal() {
		let text = '';

		switch (this.selectedLimit.tipo) {
			case PixLimitsReturnTipo.PIX_MESMA_TITULATIDADE: {
				text = 'Seu limite diário de pagamentos e transferências Pix para você mesmo, foi ajustado.';
				break;
			}
			case PixLimitsReturnTipo.PIX_FAVORECIDOS: {
				text = 'Seu limite diário de pagamentos e transferências Pix para favorecidos cadastrados foi ajustado.';
				break;
			}
			case PixLimitsReturnTipo.PIX_NAO_FAVORECIDOS: {
				text = 'Seu limite diário de pagamentos e transferências Pix para favorecidos não cadastrados, foi ajustado.';
				break;
			}
			case PixLimitsReturnTipo.PIX_QRCODE: {
				text = 'Seu limite diário para pagamentos com Pix QR Code, foi ajustado.';
				break;
			}
			case PixLimitsReturnTipo.PIX_FORA_HORARIO: {
				text = 'Seu limite noturno para pagamentos e transferências Pix, foi ajustado.';
				break;
			}
		}

		const dialogRef = this.dialog.open(SharedModalInfoComponent, {
			width: '300px',
			data: {
				title: 'Limite Pix ajustado',
				text: text,
				btnName: 'OK',
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.router.navigate(['pix/limites']);
			}
		});
	}

	handleError = (error) => AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
	goBack = () => this.router.navigate(['pix/limites/ajustar/']);
}






// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/limits/assignature/assignature.component.ts